import { Link } from 'react-router-dom';
import { seriesList } from '@/mocks/series';

const updateList = [...seriesList]
  .sort((a, b) => (a.updateDate < b.updateDate ? 1 : -1))
  .slice(0, 6);

export default function UpdateFeed() {
  return (
    <section className="w-full bg-background-100">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid gap-8 lg:grid-cols-[1fr_1.4fr] lg:gap-12">
          <div>
            <p className="font-label text-xs uppercase tracking-[0.2em] text-accent-600">Latest Updates</p>
            <h2 className="mt-2 font-heading text-xl font-semibold text-foreground-950 md:text-3xl">新剧上线与更新动态</h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-500">
              追剧不错过任何一集。这里汇总近期上线的全新剧集与正在更新的热门剧集，按更新时间实时排列，点击即可进入详情页查看剧集章节。
            </p>
            <Link
              to="/category"
              className="mt-6 inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-calendar-schedule-line text-lg" />
              浏览全部更新
            </Link>
          </div>

          <ul className="flex flex-col gap-3">
            {updateList.map((series) => (
              <li key={series.id}>
                <Link
                  to={`/detail/${series.id}`}
                  className="group flex cursor-pointer items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300"
                >
                  <div className="relative h-[84px] w-14 shrink-0 overflow-hidden rounded-md bg-background-200">
                    <img
                      src={series.poster}
                      alt={`${series.title} 剧集封面`}
                      title={`${series.title} 更新动态`}
                      className="h-full w-full object-cover object-top"
                    />
                  </div>
                  <div className="min-w-0 flex-1">
                    <div className="flex flex-wrap items-center gap-2">
                      <h3 className="truncate text-sm font-medium text-foreground-950 group-hover:text-primary-600 md:text-base">
                        {series.title}
                      </h3>
                      <span className="rounded-sm bg-accent-100 px-1.5 py-0.5 font-label text-[11px] font-medium text-accent-800">
                        {series.status}
                      </span>
                    </div>
                    <p className="mt-1.5 line-clamp-1 text-xs text-foreground-500">{series.synopsis}</p>
                    <div className="mt-2 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-foreground-400">
                      <span className="flex items-center gap-1">
                        <i className="ri-calendar-line" />
                        {series.updateDate}
                      </span>
                      <span>{series.region}</span>
                      <span>{series.genres.join(' · ')}</span>
                    </div>
                  </div>
                  <i className="ri-arrow-right-s-line hidden text-xl text-foreground-300 transition-colors group-hover:text-primary-500 sm:block" />
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}